import React from "react";
import { HiAcademicCap } from "react-icons/hi2";
import { IoChevronBack } from "react-icons/io5";
import { Link } from "react-router-dom";

interface IProps {
  title: string;
}

const AcademyHead: React.FC<IProps> = ({ title }) => {
  return (
    <>
      <div className=" my-1">
        <div className=" flex flex-row items-center lg:items-center justify-start gap-x-1 cursor-pointer transition-all w-full lg:w-32 rounded-xl hover:underline ">
          <IoChevronBack className="" size={18} />
          <Link to={"/academy/academy/product"} className="  text-xs ">
            Geri Dön
          </Link>
        </div>
      </div>

      
      <div className=" relative flex justify-center items-center w-full lg:w-1/2 mx-2 lg:mx-auto rounded-xl py-4 border  border-primary-color  ">
        <h2 className=" font-bold text-lg lg:text-2xl text-primary-color text-center">
          {title}
        </h2>
        <div className=" absolute -top-2 -right-2">
          <HiAcademicCap className=" text-white text-4xl border rounded-full p-1 bg-primary-color" />
        </div>
      </div>
    </>
  );
};

export default AcademyHead;
